<template lang="pug">
	div
		table(style="width:100%;")
			thead
				tr
					// Aquí van ahora los días de la semana
					td.text-center.p-1.numSemana Semana
					td.text-center.p-1(v-for="dia in diasSemana", :key="dia") {{dia}}
			tbody
				tr(v-for="semana in getSemanas", :key="semana.numero")
					td.numSemana(style="cursor:pointer;", @click="verSemana(semana.dias[0].dia)") {{semana.numero}}
					v-touch.diaMes(tag="td", v-for="dia in semana.dias", :key="dia.dia.getTime()", :style="estiloDia(dia.dia)", @dblclick="crearEntrada(dia.dia)", v-on:press="crearEntrada(dia.dia)")
						span(style="cursor:pointer", @click="verDia(dia.dia)") {{dia.dia.getDate()}}
						span(v-if="dia.dia.toLocaleDateString() === new Date().toLocaleDateString()")  (Hoy)
						div.evento(v-for="evento in dia.eventos", :key="evento.ID_evento", :style="estiloEvento(dia.dia, evento)", @click="verEntrada(evento)")
							| {{evento.fechaIni | moment('HH:mm')}} - {{evento.usuarioNombre}} - {{evento.clienteNombre}}
</template>

<script>
export default {
	props: ['fecha', 'entradas'],
	data () {
		return {
			diasSemana: ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom']
		}
	},

	computed: {
		fechaInicioMes () {
			const fecha = new Date(this.fecha.getTime())
			fecha.setDate(1)
			fecha.setHours(0)
			fecha.setMinutes(0)
			fecha.setSeconds(0)
			fecha.setMilliseconds(0)
			return fecha
		},
		getSemanas () {
			// Calculamos el día de la semana en el que empieza el mes
			this.fecha.setDate(1)
			const inicioMes = (this.fecha.getDay() > 0) ? this.fecha.getDay() - 1 : 6

			// offset de días del mes anterios
			const anteriores = inicioMes

			// Iremos construyendo las semanas una a una
			const semanas = []

			// La primera semana contendrá (si es necesario) los días del mes anterior
			const mesSiguiente = new Date(this.fecha.getTime())
			mesSiguiente.setMonth(mesSiguiente.getMonth() + 1)
			let fecha = new Date(this.fecha.getTime())
			fecha.setDate(1)
			fecha.setHours(0)
			fecha.setMinutes(0)
			fecha.setMilliseconds(0)

			if (anteriores > 0) {
				fecha.setDate(fecha.getDate() - anteriores)
			}

			while (fecha.getMonth() !== mesSiguiente.getMonth()) {
				const semana = {
					numero: this.$moment(fecha).isoWeek(),
					dias: []
				}
				for (let d = 0; d < 7; d++) {
					const nuevoDia = {
						dia: new Date(fecha.getTime()),
						eventos: []
					}
					const inicioDia = new Date(nuevoDia.dia.getTime())
					inicioDia.setHours(0)
					inicioDia.setMinutes(0)
					inicioDia.setSeconds(0)
					inicioDia.setMilliseconds(0)

					const finDia = new Date(nuevoDia.dia.getTime())
					finDia.setHours(23)
					finDia.setMinutes(59)
					finDia.setSeconds(59)
					finDia.setMilliseconds(999)

					const diaStr = nuevoDia.dia.getFullYear() + '' + nuevoDia.dia.getMonth() + '' + nuevoDia.dia.getDate()

					// Extraemos los eventos
					for (let i = 0; i < this.entradas.length; i++) {
						const ev = this.entradas[i]
						// Calculamos si el evento está dentro de este día
						const fechaIni = this.entradas[i].fechaIni
						const diaIni = fechaIni.getFullYear() + '' + fechaIni.getMonth() + '' + fechaIni.getDate()
						const fechaFin = this.entradas[i].fechaFin
						const diaFin = fechaFin.getFullYear() + '' + fechaFin.getMonth() + '' + fechaFin.getDate()

						// El evento está en el mismo día
						if (diaStr === diaIni) {
							nuevoDia.eventos.push(ev)
						} else if (inicioDia > fechaIni && finDia < fechaFin) {
							nuevoDia.eventos.push(ev)
						} else if (diaStr === diaFin) {
							nuevoDia.eventos.push(ev)
						}
					}

					semana.dias.push(nuevoDia)

					fecha.setDate(fecha.getDate() + 1)
				}

				semanas.push(semana)
			}

			return semanas
		}
	},

	methods: {
		verEntrada (entrada) {
			this.$emit('editar', {
				ID_entrada: entrada.ID_entrada,
				fecha: null,
				hora: null
			})
		},

		crearEntrada (fecha) {
			this.$emit('editar', {
				ID_entrada: 'nuevo',
				fecha: fecha,
				hora: null
			})
		},

		estiloDia (dia) {
			if (dia.toLocaleDateString() === new Date().toLocaleDateString()) {
				return {
					'background-color': '#fbfbfb',
					'font-weight': 'bold'
				}
			}
			if (dia.getMonth() !== this.fecha.getMonth()) {
				return {
					'background-color': '#f0f0f0',
					'color': '#888888'
				}
			} else {
				return {}
			}
		},

		estiloEvento (dia, evento) {
			const diaStr = dia.getFullYear() + '' + dia.getMonth() + '' + dia.getDate()
			const inicioStr = evento.fechaIni.getFullYear() + '' + evento.fechaIni.getMonth() + '' + evento.fechaIni.getDate()
			const finStr = evento.fechaFin.getFullYear() + '' + evento.fechaFin.getMonth() + '' + evento.fechaFin.getDate()

			const estilo = {
				borderRadius: ['0', '0', '0', '0'],
				backgroundColor: evento.bgColor,
				color: evento.textColor,
				marginTop: '2px'
			}

			if (diaStr === inicioStr) {
				estilo.borderRadius[0] = '5px'
				estilo.borderRadius[3] = '5px'

				if (diaStr !== finStr) {
					estilo.marginRight = '-6px'
				}
			}

			if (diaStr === finStr) {
				estilo.borderRadius[1] = '5px'
				estilo.borderRadius[2] = '5px'

				if (diaStr !== inicioStr) {
					estilo.marginLeft = '-6px'
				}

				if (inicioStr !== finStr) {
					estilo.textAlign = 'right'
				}
			}

			if (diaStr !== inicioStr && diaStr !== finStr) {
				estilo.marginLeft = '-6px'
				estilo.marginRight = '-6px'
				estilo.color = evento.bgColor
			}

			estilo.borderRadius = estilo.borderRadius.join(' ')

			return estilo
		},

		verSemana (fecha) {
			this.$emit('verSemana', fecha)
		},

		verDia (fecha) {
			this.$emit('verDia', fecha)
		}
	}
}
</script>

<style scoped>
	tr {
		position: relative;
		display: table-row;
	}
	td {
		position: relative;
		border: 1px solid #e0e0e0;
		display: table-cell;
	}

	td.numSemana {
		vertical-align: top;
		text-align: center;
		/* font-weight: bold; */
		/* font-size: 1.3em; */
		padding-top: 5px;
		background-color: rgb(52, 58, 64);
		border-color: white;
		color: white;
		width: 80px;
	}

	td.diaMes {
		height: 200px;
		vertical-align:top;
		position:relative;
		padding: 5px;
		width: 14%;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	div.evento {
		position: relative;
		display: block;
		padding: 5px;
		border-radius: 5px;
		text-align: left;
		cursor: move;
		font-size: 0.8em;
		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari */
		-khtml-user-select: none; /* Konqueror HTML */
		-moz-user-select: none; /* Firefox */
			-ms-user-select: none; /* Internet Explorer/Edge */
				user-select: none; /* Non-prefixed version, currently
									supported by Chrome and Opera */
	}
</style>



// WEBPACK FOOTER //
// src/modulos/agenda-comercial/vue/componentes/calendario/mes.vue